<template xmlns:mailto="http://www.w3.org/1999/xhtml">
  <div
    class="alert alert-calendar col-md-8"
    style="font-size: 18px; text-align: center; width: 100%"
  >
    <span
      class="pull-right"
      style="margin-left: 15px; color: black; cursor: pointer; transition: 0.7s"
      onclick="this.parentElement.style.display='none';"
    >
      &times;
    </span>
    <div style="text-align: left; padding-left: 15px">
      <h3 style="text-transform: none">Przed nami majówka! 🌞</h3>
      Aby zapewnić Ci pełen komfort korzystania z naszych usług, przekazujemy
      kilka ważnych informacji dotyczących majowych dostaw oraz godzin pracy
      Biura Obsługi Klienta:<br />
      📦 Harmonogram dostaw: Dostawy podczas majówki realizujemy bez zmian –
      wszystko przyjedzie zgodnie ze standardowym grafikiem! ☺️<br />
      <b>📞 Godziny pracy Biura Obsługi Klienta:</b><br />
      <ul style="list-style: inside">
        <li><b>1 maja</b> – nieczynne</li>
        <li><b>2 maja</b> – czynne od <b>7:00 do 15:00</b></li>
        <li><b>3 maja</b> – nieczynne</li>
      </ul>
      Dziękujemy za wyrozumiałość i życzymy pięknego, słonecznego weekendu
      majowego! 🌻<br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NtfyMessageTemporary'
}
</script>
